import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=ed50b484&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports